package com.essntl.uikit.components.toggle

data class TabState(
    val index: Int,
    val text: String,
    val suffix: String? = null,
    val enabled : Boolean = true,
)
